import {createAction} from '@reduxjs/toolkit'
import {Toast} from '../components/toast-handler/interfaces'

export const setToast = createAction<Toast>('SET_TOAST')
